import { type ComponentType, lazy } from "react";

// project imports
import MainLayout from "../layout/MainLayout";
import Loadable from "../ui-component/Loadable";
import DashboardDefault from "../views/dashboard/Default";
import AcknowledgementAdminRequest from "../views/pages/acknowledgementAdminRequest";
import Departments from "../views/pages/department";
import Designations from "../views/pages/designation";
import DocumentRequestForMe from "../views/pages/RequestForMe";
import EmployeeDetails from "../views/pages/employeeDetails";
import AddPublicCalendar from "../views/configurations";
import AdminAccess from "../utils/AdminAccess";
import { Outlet } from "react-router-dom";
import { type SvgIconProps } from "@mui/material";

const FinancialReport = Loadable(lazy(async () => await import("../views/pages/financialReport")));
const Document = Loadable(lazy(async () => await import("../views/pages/document")));
const AddDocument = Loadable(lazy(async () => await import("../views/pages/document/AddDocument")));
const ReuploadDocument = Loadable(
  lazy(async () => await import("../views/pages/document/ReuploadDocument"))
);
const EmployeeDocumentAcknowledgements = Loadable(
  lazy(
    async () =>
      await import("../views/pages/document/EmployeeDocumentAcknowledgements")
  )
);
const InternalApplication = Loadable(
  lazy(async () => await import("../views/pages/internalApplication"))
);
const AddInternalApp = Loadable(
  lazy(async () => await import("../views/pages/internalApplication/AddInternalApp"))
);
const MoodMonitor = Loadable(lazy(async () => await import("../views/pages/moodMonitor")));
const AddMoodEmoji = Loadable(
  lazy(async () => await import("../views/pages/moodMonitor/AddMoodEmoji"))
);
const TicketPage = Loadable(lazy(async () => await import("@/views/pages/tickets")));
const AllEmployee = Loadable(lazy(async () => await import("../views/pages/allEmployee")));

// ==============================|| MAIN ROUTING ||============================== //

export interface childRouteType {
  breadcrumbs?: boolean;
  guardName: string;
  icon: ComponentType<SvgIconProps>;
  id: string;
  title: string;
  type: string;
  url: string;
}

export interface routeType {
  children: childRouteType[];
  id: string;
  title: string;
  type: string;
}

const adminRoutes = [
  {
    path: "internal-application",
    element: (
      <AdminAccess requiredRoles="admin">
        <InternalApplication />
      </AdminAccess>
    )
  },
  {
    path: "add-internal-application",
    element: (
      <AdminAccess requiredRoles="admin">
        <AddInternalApp />
      </AdminAccess>
    )
  },
  {
    path: "add-internal-application/:id",
    element: (
      <AdminAccess requiredRoles="admin">
        <AddInternalApp />
      </AdminAccess>
    )
  },
  {
    path: "mood-monitor",
    element: (
      <AdminAccess requiredRoles="admin">
        <MoodMonitor />
      </AdminAccess>
    )
  },
  {
    path: "add-mood-emoji",
    element: (
      <AdminAccess requiredRoles="admin">
        <AddMoodEmoji />
      </AdminAccess>
    )
  },
  {
    path: "add-mood-emoji/:id",
    element: (
      <AdminAccess requiredRoles="admin">
        <AddMoodEmoji />
      </AdminAccess>
    )
  },
  {
    path: "document",
    element: (
      <AdminAccess requiredRoles="admin">
        <Document />
      </AdminAccess>
    )
  },
  {
    path: "add-document",
    element: (
      <AdminAccess requiredRoles="admin">
        <AddDocument />
      </AdminAccess>
    )
  },
  {
    path: "reupload-document",
    element: (
      <AdminAccess requiredRoles="admin">
        <ReuploadDocument />
      </AdminAccess>
    )
  },
  {
    path: "acknowledgement-request",
    element: (
      <AdminAccess requiredRoles="admin">
        <AcknowledgementAdminRequest />
      </AdminAccess>
    )
  },
  {
    path: "employee-document-acknowledgements",
    element: (
      <AdminAccess requiredRoles="admin">
        <EmployeeDocumentAcknowledgements />
      </AdminAccess>
    )
  },
  {
    path: "financial-report",
    element: (
      <AdminAccess requiredRoles="admin">
        <FinancialReport />
      </AdminAccess>
    )
  }
];

const MainRoutes = {
  path: "/",
  element: <MainLayout />,
  children: [
    {
      path: "",
      element: <DashboardDefault />
    },
    {
      path: "pages",
      children: [
        ...adminRoutes,
        {
          path: "all-employee",
          element: <AllEmployee />
        },
        {
          path: "tickets",
          element: <Outlet />,
          children: [
            {
              index: true,
              element: <TicketPage />
            }
          ]
        },
        {
          path: "document-acknowledgement-request-for-me",
          element: <DocumentRequestForMe />
        },
        {
          path: "departments",
          element: <Departments />
        },
        {
          path: "designations",
          element: <Designations />
        },
        {
          path: "employee-details",
          element: <EmployeeDetails />
        }
      ]
    },
    {
      path: "configurations",
      children: [
        {
          path: "public-calendar",
          element: (
            <AdminAccess requiredRoles="admin">
              <AddPublicCalendar />
            </AdminAccess>
          )
        }
      ]
    }
  ]
};

export default MainRoutes;
